// src/firebaseAuth.js
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile, // ✅ AJOUT (optionnel mais utile)
} from "firebase/auth";

import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage"; // ✅ AJOUT

import app, { db } from "./firebase.js";

const auth = getAuth(app);
const storage = getStorage(app); // ✅ AJOUT

// ✅ Inscription + création du document Firestore (+ photo optionnelle)
export const registerUser = async (email, password, profileData = {}) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;

    const telephone =
      (profileData.telephone || "").toString().replace(/\s+/g, "").trim();

    // ✅ Photo optionnelle
    let photoURL = "";
    const photoFile = profileData.photoFile;

    if (photoFile instanceof File) {
      // Chemin Storage : users/{uid}/profile.jpg (ou nom unique)
      const safeName = (photoFile.name || "photo").replace(/\s+/g, "_");
      const fileRef = ref(storage, `users/${user.uid}/${Date.now()}_${safeName}`);

      await uploadBytes(fileRef, photoFile, {
        contentType: photoFile.type || "image/jpeg",
      });

      photoURL = await getDownloadURL(fileRef);
    }

    // ✅ (Optionnel) Mettre aussi la photo/displayName dans Firebase Auth
    const displayName = `${(profileData.prenom || "").trim()} ${(profileData.nom || "").trim()}`.trim();
    if (displayName || photoURL) {
      await updateProfile(user, {
        displayName: displayName || user.displayName || "",
        photoURL: photoURL || user.photoURL || "",
      });
    }

    await setDoc(doc(db, "users", user.uid), {
      email: user.email,
      prenom: (profileData.prenom || "").trim(),
      nom: (profileData.nom || "").trim(),
      age: profileData.age ?? null,
      profession: (profileData.profession || "").trim(),
      residence: (profileData.residence || "").trim(),
      telephone,
      countryCode: (profileData.countryCode || "").trim(),
      photoURL: photoURL || "", // ✅ AJOUT
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });

    console.log("✅ Compte + profil créés :", user.email);
    return user;
  } catch (error) {
    console.error("❌ Erreur inscription :", error.message);
    throw error;
  }
};

// Connexion
export const loginUser = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
};

// Déconnexion
export const logoutUser = async () => {
  await signOut(auth);
};

export default auth;
